var map = {
	"./ConfitureW255.png": 6148,
	"./ConserveBioW255.png": 58660,
	"./FromaggioW255.png": 73650,
	"./MieleW255.png": 80175,
	"./OlioRecW255.png": 64608,
	"./TartufiFunghiW255.png": 60725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20329;